import { useStore } from "../../store";
import { logoutAuthenticatedUser } from "../../services/authServices";
import { Button, Size, Variant } from "../../components/Buttons";
import { Actions, Card, View } from "./styles";

export const ProductAccessUnavailable = () => {
  const { logout } = useStore();

  const handleLogout = async () => {
    await logoutAuthenticatedUser();
    logout();
    window.history.replaceState( null, "", "/" );
    window.location.reload();
  };

  return (
    <View>
      <Card>
        <span>Acesso ao produto</span>
        <h1>Void Chat não está disponível para sua organização.</h1>
        <p>
          Sua sessão está autenticada, mas este produto não faz parte do pacote contratado ou não está liberado para o seu nível de acesso.
        </p>
        <p>
          Se você precisa usar o Void Chat, fale com o administrador da sua organização ou com o suporte da Void Orbit.
        </p>
        <Actions>
          <Button
            onClick={ handleLogout }
            $color="primary"
            $size={ Size.LARGE }
            $variant={ Variant.CONTAINED }
          >
            Sair da conta
          </Button>
        </Actions>
      </Card>
    </View>
  );
};
